import { useMemo } from "react";

export default function LegalLayout({ eyebrow, title, lastUpdated, sections, children }) {
  const toc = useMemo(() => sections?.map((s) => ({ id: s.id, title: s.title })) || [], [sections]);

  return (
    <div className="bg-[#FBFBF9]">
      <section className="bg-[#EDF1ED] border-b border-[#D5DDD7]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24">
          <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#1A3A32]">{eyebrow}</p>
          <h1 className="mt-4 text-5xl sm:text-6xl tracking-tight leading-none font-bold text-[#14241F]">{title}</h1>
          <p className="mt-6 text-sm text-[#495D56]">Last updated: <span className="font-medium text-[#14241F]">{lastUpdated}</span></p>
        </div>
      </section>

      <section className="py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
          {toc.length > 0 && (
            <aside className="lg:col-span-3 order-2 lg:order-1">
              <div className="lg:sticky lg:top-24">
                <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#1A3A32]">On this page</p>
                <nav className="mt-4 space-y-1.5 text-sm">
                  {toc.map((t, i) => (
                    <a
                      key={t.id}
                      href={`#${t.id}`}
                      data-testid={`legal-toc-${i}`}
                      className="block py-1.5 text-[#495D56] hover:text-[#1A3A32] border-l-2 border-transparent hover:border-[#E5383B] pl-3 transition-colors"
                    >
                      {t.title}
                    </a>
                  ))}
                </nav>
              </div>
            </aside>
          )}

          <article className="lg:col-span-9 order-1 lg:order-2">
            <div className="prose-ambuly max-w-3xl">
              {children}
              {sections?.map((s) => (
                <section key={s.id} id={s.id} className="scroll-mt-24 mt-12 first:mt-0">
                  <h2 className="text-3xl sm:text-4xl font-[Outfit] font-semibold text-[#14241F]">{s.title}</h2>
                  <div className="mt-5 space-y-4 text-[#495D56] text-[17px] leading-relaxed">
                    {s.body}
                  </div>
                </section>
              ))}
            </div>
          </article>
        </div>
      </section>
    </div>
  );
}

export function P({ children }) {
  return <p className="text-[#495D56] leading-relaxed">{children}</p>;
}

export function UL({ items }) {
  return (
    <ul className="mt-3 space-y-2 text-[#495D56]">
      {items.map((it, i) => (
        <li key={i} className="flex items-start gap-3">
          <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#E5383B] flex-shrink-0" />
          <span>{it}</span>
        </li>
      ))}
    </ul>
  );
}

export function H3({ children }) {
  return <h3 className="mt-6 text-xl font-[Outfit] font-semibold text-[#14241F]">{children}</h3>;
}
